//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
export default {
  name: 'SearchDataStudio',
  components: {
    OrganizacionComponent: OrganizacionComponent
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search by datasource criteria ...'
    },
    searchAdvanced: {
      type: Boolean,
      default: true
    },
    showDomains: {
      type: Boolean,
      default: true
    },
    defaultDomain: {
      type: String,
      default: null
    },
    typeObject: {
      type: String,
      default: 'datasource'
    }
  },
  data: function data() {
    return {
      query: '',
      showOptions: false,
      select_domain: null,
      criteria: {
        name: '',
        path_name: '',
        column_name: '',
        data_operator: '',
        env: '' // vacío por defecto => Todos los entornos
      }
    };
  },
  computed: {
    list_env: function list_env() {
      return [{
        value: '',
        text: 'Todos los entornos'
      }, {
        value: 'dev',
        text: this.traductor('my_tasks.dev_test')
      }, {
        value: 'prod',
        text: this.traductor('my_tasks.production')
      }];
    }
  },
  created: function created() {
    this.select_domain = this.defaultDomain || (window.userInfo ? window.userInfo.domain : null);
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    prepareData: function prepareData() {
      var _this$criteria = this.criteria,
        name = _this$criteria.name,
        path_name = _this$criteria.path_name,
        data_operator = _this$criteria.data_operator,
        env = _this$criteria.env,
        column_name = _this$criteria.column_name;
      var clauseObj = {};
      if (name) clauseObj['object_name'] = name;
      if (path_name) clauseObj['path_name'] = path_name;
      if (data_operator) clauseObj['data_operator'] = data_operator;
      if (env) clauseObj['environment'] = env;
      if (column_name) clauseObj['column'] = column_name;
      return {
        domain: this.select_domain,
        clauses: clauseObj
      };
    },
    runQuery: function runQuery() {
      this.$emit('onSearchQuery', this.prepareData());
    },
    onSearchAdvanced: function onSearchAdvanced() {
      this.runQuery();
    },
    onResetAdvanced: function onResetAdvanced() {
      this.criteria = {
        name: '',
        path_name: '',
        column_name: '',
        data_operator: '',
        env: '' // limpiar => Todos los entornos
      };
      this.runQuery();
    },
    onSelectDomain: function onSelectDomain() {
      this.runQuery();
    }
  }
};